import React, { useContext } from 'react'
import { DataContext } from './DataContext'
import AggregateResetSelector from '../../../../elem/chart/AggregateResetSelector'

const ResetDropdown = () => {
    const { resetZoom, resetMeasures, resetExpanded, toggleResetExpanded } = useContext(DataContext)

    const onResetMeasures = () => {
        resetMeasures()
        toggleResetExpanded(false)
    }

    const onResetZoom = () => {
        resetZoom()
        toggleResetExpanded(false)
    }

    return (
        <AggregateResetSelector
            resetExpanded={resetExpanded}
            resetMeasuresFunction={onResetMeasures}
            resetZoomFunction={onResetZoom}
        />
    )
}

export default ResetDropdown